import React, { useState } from 'react';
interface SyrupSelectionProps {
  bibSyrups: string[];
  bottleSyrups: Record<string, number>;
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBottleQuantityChange: (name: string, quantity: number) => void;
}
export function SyrupSelection({
  bibSyrups,
  bottleSyrups,
  handleCheckboxChange,
  handleBottleQuantityChange
}: SyrupSelectionProps) {
  const bibOptions = ['Vlierbloesem', 'Citroen', 'Iced Tea', 'Blood Orange', 'Ginger Lime'];
  const bottleOptions = ['Blood Orange', 'Citroen', 'Cranberry Rose Hip', 'Dennen Agave', 'Ginger Lime', 'Ice Tea', 'Maté Ginseng', 'Rabarber', 'Sassafras Rootbeer', 'Tonic', 'Vlierbloesem', 'Strawberry', 'Zwarte Bes'];
  // Function to handle direct input changes with a max of 600
  const handleDirectInputChange = (syrup: string, value: string) => {
    const numValue = parseInt(value) || 0;
    const clampedValue = Math.min(600, Math.max(0, numValue));
    handleBottleQuantityChange(syrup, clampedValue);
  };
  // Function to round slider values to multiples of 6
  const roundToSix = (value: number) => {
    return Math.round(value / 6) * 6;
  };
  return <div className="space-y-6" data-id="element-110">
      <div className="flex justify-between items-center" data-id="element-111">
        <h2 className="text-xl font-semibold text-[#052858]" data-id="element-112">
          Siropen Selectie{' '}
          <span className="text-sm font-normal text-gray-500" data-id="element-113">(optioneel)</span>
        </h2>
      </div>
      <div className="bg-[#C8FAF1] bg-opacity-30 p-5 rounded-lg shadow-sm" data-id="element-114">
        <div className="flex flex-col md:flex-row gap-5 mb-4" data-id="element-115">
          <div className="flex-1" data-id="element-116">
            <h3 className="font-medium text-[#052858] mb-1" data-id="element-117">
              BiB (Bag-in-Box) Siropen
            </h3>
            <p className="text-sm font-normal text-gray-500 mb-3" data-id="element-118">
              (indien van toepassing)
            </p>
            <div className="mb-4 p-3 bg-white bg-opacity-50 rounded-md" data-id="element-119">
              <p className="text-sm text-gray-700" data-id="element-120">
                Indien u heeft gekozen voor een siropenbar, kunt u hieronder
                twee of drie smaken selecteren.
              </p>
            </div>
          </div>
          <div className="md:w-2/5 flex items-center justify-center" data-id="element-121">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kjcBHsgca86QpyGFztNfak/KRNWTR2B_-_productfoto_-_siropenbar_3_%281%29.jpg" alt="KRNWTR+ Siropenbar" className="rounded-lg shadow-md max-h-48 object-contain" data-id="element-122" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-123">
          {bibOptions.map(syrup => <div key={`bib-${syrup}`} className="flex items-center bg-white bg-opacity-50 p-2 rounded-md" data-id="element-124">
              <input type="checkbox" id={`bib-${syrup}`} name={`bib-${syrup}`} checked={bibSyrups.includes(syrup)} onChange={handleCheckboxChange} className="h-5 w-5 text-[#19EAC4] focus:ring-[#19EAC4] border-gray-300 rounded" data-id="element-125" />
              <label htmlFor={`bib-${syrup}`} className="ml-2 block text-sm text-gray-700 font-medium" data-id="element-126">
                {syrup}
              </label>
            </div>)}
        </div>
        <div className="mt-3 p-3 bg-white bg-opacity-50 rounded-md" data-id="element-127">
          <p className="text-sm text-gray-700" data-id="element-128">
            * Heeft u in de offerte gekozen voor meer dan drie smaken? Vul de
            gewenste extra smaken dan gerust in onder "Overige opmerkingen" op
            de vorige pagina.
          </p>
        </div>
      </div>
      <div className="bg-[#FFD6E3] bg-opacity-30 p-5 rounded-lg shadow-sm" data-id="element-129">
        <div className="flex flex-col md:flex-row gap-5 mb-4" data-id="element-130">
          <div className="flex-1" data-id="element-131">
            <h3 className="font-medium text-[#052858] mb-1" data-id="element-132">
              Flessen Siropen (1L)
            </h3>
            <p className="text-sm font-normal text-gray-500 mb-3" data-id="element-133">
              (indien van toepassing)
            </p>
            <div className="mb-4 p-3 bg-white bg-opacity-50 rounded-md" data-id="element-134">
              <p className="text-sm text-gray-700" data-id="element-135">
                De siropenflessen worden geleverd per doos van 6. U kunt hierbij
                verschillende smaken combineren.
              </p>
            </div>
          </div>
          <div className="md:w-1/3 flex items-center justify-center" data-id="element-136">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m1iR6gWtGrJZuPyxM49r1P/unnamed.png" alt="KRNWTR+ Siropen Flessen" className="rounded-lg shadow-md max-h-48 object-contain" data-id="element-137" />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-138">
          {bottleOptions.map(syrup => <div key={`bottle-${syrup}`} className="bg-white bg-opacity-50 p-3 rounded-md" data-id="element-139">
              <div className="flex justify-between items-center mb-1" data-id="element-140">
                <span className="text-sm font-medium text-gray-700" data-id="element-141">
                  {syrup}
                </span>
                <div className="flex items-center" data-id="element-142">
                  <input type="number" min="0" max="600" value={bottleSyrups[syrup] || 0} onChange={e => handleDirectInputChange(syrup, e.target.value)} className="w-16 h-8 text-center border border-[#19EAC4] rounded-md focus:outline-none focus:ring-2 focus:ring-[#19EAC4]" data-id="element-143" />
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-144">
                <span className="text-xs text-gray-500" data-id="element-145">0</span>
                <input type="range" min="0" max="60" step="6" value={Math.min(60, bottleSyrups[syrup] || 0)} onChange={e => handleBottleQuantityChange(syrup, parseInt(e.target.value))} className="flex-grow h-2 appearance-none bg-gray-200 rounded-full accent-[#FF558A] focus:outline-none" data-id="element-146" />
                <span className="text-xs text-gray-500" data-id="element-147">60</span>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}